export { default } from './part-accordion-item';
